import React, { createRef } from 'react';
import PropTypes from 'prop-types';

import * as types from '../../constants/actionTypes';
import Routes from '../../constants/routes';

import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import Modal61 from '../Common/Modal/Modal61';
import InputText from '../Common/InputText';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import TaskListOption from '../TaskList/TaskListOption';
import Notification from '../Common/Notification';

import { CORPORATE_DASHBOARD_DEFAULT, CORPORATE_DASHBOARD_DEFAULT_MANAGE } from '../../constants/constants';
const { CORPORATE_DASHBOARD_VIEW_DEFAULT_ID, SAVE_CURRENT_VIEW_TEXT, SAVE_CURRENT_VIEW_ID } = CORPORATE_DASHBOARD_DEFAULT;
const { SAVE_CURRENT_VIEW_MANAGE_TEXT, SAVE_CURRENT_VIEW_MANAGE_ID } = CORPORATE_DASHBOARD_DEFAULT_MANAGE;

export class CorporateDashboardHeader extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: false,
            settings: [],
            selectedSettings: {},
            selectedSettingsId: '',
            matchingSettings: [],
            manageCorporateViews: false
        };

        this.saveFiltersModal = createRef();
    }
    componentDidMount = async () => {
        this.buildSettings();
    };

    componentDidUpdate = (prevProps) => {
        if (
            this.props.lastItemIdDeleted !== '' &&
            this.state.selectedSettingsId !== ''
        ) {
            const excludedIds = [CORPORATE_DASHBOARD_VIEW_DEFAULT_ID, SAVE_CURRENT_VIEW_MANAGE_ID, SAVE_CURRENT_VIEW_ID, "defaultId"];
            const options = this.getSettingsMenuOptions();
            const firstValid = options.find(item => !excludedIds.includes(item.id))?.id || "";
    
            if (firstValid && firstValid !== this.state.selectedSettingsId) {
                this.setState({ selectedSettingsId: firstValid }, () => {
                    this.props.cleanLastViewDeleted();
                });
            }
        }

        if (
            prevProps.settings === this.props.settings &&
            prevProps.selectedSettings === this.props.selectedSettings &&
            prevProps.selectedSettingsId === this.props.selectedSettingsId &&
            prevProps.matchingSettings === this.props.matchingSettings
        ) {
            return;
        }

        this.buildSettings();
    };

    buildSettings = () => {
        this.setState({
            settings: this.props.settings,
            selectedSettings: this.props.selectedSettings,
            selectedSettingsId: this.props.selectedSettingsId,
            matchingSettings: this.props.matchingSettings,
        })
    };

    onSaveViewClick = () => {
        this.saveFiltersModal.current.show();
    };

    hideModal = () => {
        this.props.reloadSettings();
        // this.saveFiltersModal.current.hide();
    };

    onSaveCustomFilters = async () => {
        this.setState({ isLoading: true });
        const { selectedSettings } = this.state;
        if (selectedSettings.id == CORPORATE_DASHBOARD_VIEW_DEFAULT_ID) selectedSettings.id = undefined;

        try {
            let response, successType, failureType = undefined;
            if (selectedSettings.id) {
                response = await this.props.companyDashboardActions.updateSettingsV2(selectedSettings, selectedSettings.id);
                successType = types.UPDATE_COMPANY_DASHBOARD_SETTINGS_SUCCESS;
                failureType = types.UPDATE_COMPANY_DASHBOARD_SETTINGS_FAILURE;
            } else {
                response = await this.props.companyDashboardActions.saveSettingsV2(selectedSettings);
                successType = types.SAVE_COMPANY_DASHBOARD_SETTINGS_SUCCESS;
                failureType = types.SAVE_COMPANY_DASHBOARD_SETTINGS_FAILURE;
            }

            if (response.type === successType) {
                Notification('success', 'Settings Updated and Saved', '');
                this.hideModal();
            } else if (response.type === failureType) {
                Notification('error', 'Error', response.payload.message);
            }
        } catch (error) {
            Notification('error', 'Error', error);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    getSettingsMenuOptions = () => {
        let options = this.state.settings.map(setting => ({
            id: setting.id ?? CORPORATE_DASHBOARD_VIEW_DEFAULT_ID,
            name: setting.name ?? 'Unsaved View',
            itemIcon: 'list-check'
        }));

        const isEmptyList = options.find(option => option.id === CORPORATE_DASHBOARD_VIEW_DEFAULT_ID);

        if (!isEmptyList) {
            options.push({ itemIcon: 'plus', id: CORPORATE_DASHBOARD_VIEW_DEFAULT_ID, name: 'Create new view', isSeparator: true });
        }

        options.push({ itemIcon: 'pen', id: SAVE_CURRENT_VIEW_MANAGE_ID, name: SAVE_CURRENT_VIEW_MANAGE_TEXT, isSeparator: !!isEmptyList });
        options.push({ itemIcon: 'floppy-disk', id: SAVE_CURRENT_VIEW_ID, name: SAVE_CURRENT_VIEW_TEXT, isSeparator: !!isEmptyList });

        return options;
    };


    getFilterCount = () => {
        let filterCount = 0;

        for (let prop in this.state.selectedSettings) {
            if (Array.isArray(this.state.selectedSettings[prop])) {
                filterCount += this.state.selectedSettings[prop].length;
            }
        }

        if (this.state.selectedSettings.isMilestonesOnly) {
            filterCount += 1;
        }
        return filterCount;
    };

	handleSettingsMenuChange = async (menuItemValue) => {
		if (menuItemValue === SAVE_CURRENT_VIEW_ID) {
			this.onSaveViewClick();
		} else if(menuItemValue === SAVE_CURRENT_VIEW_MANAGE_ID) {
            this.props.toggleActiveState(true);
        }else {
			this.props.onSettingsMenuChange(menuItemValue);
		}
	};

    render() {
        const updateView = this.state.selectedSettings.id && this.state.selectedSettings.id != CORPORATE_DASHBOARD_VIEW_DEFAULT_ID;

        return (
            <LoadingIndicator isLoading={this.state.isLoading}>
                <div className='company-dashboard-header row justify-content-end'>
                    <div className='col-2'>
                        <MultiSelectBox
                            name='filtersView'
                            idField='id'
                            valueField='name'
                            options={this.getSettingsMenuOptions()}
                            onChange={this.handleSettingsMenuChange}
                            selectedValues={this.state.selectedSettingsId}
                            isMulti={false}
                            isSearchable={false}
                            optionComponent={TaskListOption}
                            shouldShowIcons={false}
                            placeholder='Unsaved View'
                        />
                    </div>

                    <div className="col-2">
                        <button
                            type="button"
                            className="btn btn-outline-primary me-2"
                            onClick={this.props.openCustomizerDrawer}
                        >
                            <i className="fa-regular fa-bars-filter"></i>
                            <span className="ms-2 show-filters">Filters</span>
                        </button>
                        | <span className="ms-2">{this.getFilterCount()} Applied</span>
                    </div>

                </div>

                <Modal61
                    title='Save View'
                    ref={this.saveFiltersModal}
                    body={
                        <form name='saveViewForm' noValidate>
                            <div className='form-group'>
                                <label htmlFor='custom-filters-name' className='title'>
                                    Custom View Name
                                </label>
                                <InputText
                                    name='custom-filters-name'
                                    type='text'
                                    value={this.state.selectedSettings.name}
                                    onChange={(e) => this.setState({ selectedSettings: { ...this.state.selectedSettings, ['name']: e.target.value } })}
                                    isRequired={true}
                                    errorMessage='Custom View Name is required'
                                    maxLength={20}
                                    placeholder={updateView
                                        ? 'Would you like to rename this view?'
                                        : 'What would you like to name this view?'}
                                />
                                <small id='custom-view-name-help' className='form-text text-muted sub-title'>
                                    Character Limit 20
                                </small>
                            </div>

                            {this.state.matchingSettings.length > 0 &&
                                <div className="alert alert-warning">
                                    <p>A view with the same filters already exists.</p>
                                    <p>Are you sure you want to continue?</p>
                                </div>
                            }
                        </form>
                    }
                    primaryButtonText={updateView ? 'Update' : 'Save'}
                    onPrimaryClick={this.onSaveCustomFilters}
                />
            </LoadingIndicator>
        );
    }
}

CorporateDashboardHeader.propTypes = {
    openCustomizerDrawer: PropTypes.func.isRequired,
    onSettingsMenuChange: PropTypes.func.isRequired,
    reloadSettings: PropTypes.func.isRequired,
    settings: PropTypes.array.isRequired,
    selectedSettings: PropTypes.object.isRequired,
    selectedSettingsId: PropTypes.string.isRequired,
    companyDashboardActions: PropTypes.object.isRequired,
    matchingSettings: PropTypes.array.isRequired,
    toggleActiveState: PropTypes.func.isRequired,
    lastItemIdDeleted: PropTypes.string.isRequired,
    cleanLastViewDeleted: PropTypes.func.isRequired,
};

export default CorporateDashboardHeader;